module.exports = __webpack_public_path__ + "img/hoadon.8ae8d2f8.png";